import { post } from './http';

let abortController;

export const getProductList = async (q) => {
  // abort any existing, pending request.
  // It's ok to call .abort() after the fetch has already completed, fetch simply ignores it.
  abortController && abortController.abort();
  abortController = new AbortController();
  if (!q) {
    return;
  }
  return await post('/api/quickSearch', q, abortController).then((response) =>
    response.json()
  );
};

export const getProductsByQuery = async (q) => {
  // abort any existing, pending request.
  // It's ok to call .abort() after the fetch has already completed, fetch simply ignores it.
  abortController && abortController.abort();
  abortController = new AbortController();
  return await post('/api/checkout/getProductsByQuery', q, abortController).then(
    (response) => response.json()
  );
};
